export const LIST_RECEIVABLE = 'LIST_RECEIVABLE';
export const LIST_INSTALLMENT = 'LIST_INSTALLMENT';
export const DETAIL_RECEIVABLE = 'DETAIL_RECEIVABLE';
